import PropTypes from 'prop-types';
import relatedSearchCategories from '../data/relatedSearchCategories';
import { toSlug } from '../utils/slug';
import { REF_QUERY_PARAM, REF_RELATED_SEARCH } from '../../constants';

const MAX_RELATED_TERMS = 5;

/**
 * Links each /search/{slug} page to 3-5 adjacent searches from the same product
 * category (docs/ssr-seo-distribution-plan.md Phase 1 item 3) - creates a dense
 * internal link graph between search pages themselves, which was previously zero.
 * Renders nothing when the term doesn't match a known category, so it never adds an
 * empty section.
 */
export default function RelatedSearches({ searchTerm }) {
  if (!searchTerm) return null;

  const normalizedTerm = searchTerm.toLowerCase();
  const category = relatedSearchCategories.find((cat) =>
    cat.keywords.some((keyword) => normalizedTerm.includes(keyword))
  );
  if (!category) return null;

  // Exclude near-duplicates of the current term (e.g. term "GoPro Hero XL White"
  // vs. curated "GoPro Hero") rather than just an exact-string match.
  const relatedTerms = category.terms
    .filter((term) => {
      const normalizedCandidate = term.toLowerCase();
      return (
        !normalizedTerm.includes(normalizedCandidate) && !normalizedCandidate.includes(normalizedTerm)
      );
    })
    .slice(0, MAX_RELATED_TERMS);

  if (relatedTerms.length === 0) return null;

  return (
    <section className="max-w-3xl mx-auto px-4 py-6" aria-label="חיפושים דומים">
      <h2 className="text-base font-semibold text-gray-700 mb-2">חיפושים דומים</h2>
      <ul className="flex flex-wrap gap-2">
        {relatedTerms.map((term) => (
          <li key={term}>
            <a
              href={`/search/${toSlug(term)}?${REF_QUERY_PARAM}=${REF_RELATED_SEARCH}`}
              className="inline-block px-3 py-1.5 rounded-full bg-gray-100 text-gray-800 text-sm hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300"
            >
              {term}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}

RelatedSearches.propTypes = {
  searchTerm: PropTypes.string,
};
